import React from 'react';
import EmptyState from './components/empty-state/empty-state';
import useTestingPlanController from './your-testing-plan.controller';
import TestingPlanCard from './components/testing-plan-card/testing-plan-card';

function YourTestingPlan() {
  const { recommendations } = useTestingPlanController();

  if (!recommendations || !recommendations.length) return <EmptyState />;

  return (
    <main className="dashboard-reset flex-grow">
      <h2 className="section-heading">Recommended Tests</h2>
      <div className="flex flex-col gap-4">
        {recommendations.map((testData) => (
          <TestingPlanCard screeningTypeData={testData} key={testData.id} />
        ))}
      </div>
    </main>
  );
}

export default React.memo(YourTestingPlan);
